const useRequiredFields = () => {
  // Check for missing required fields and return array of missing fields
  const checkForRequiredFields = (fields = {}, requiredFields = []) => {
    // Check for empty values and return the missing fields
    const missingFields = requiredFields.filter(
      (field) => !fields[field] || fields[field] === ""
    );
    return missingFields;
  };

  // Alert user of missing required fields
  const alertMissingFields = (fields = {}, requiredFields = []) => {
    const missingFields = checkForRequiredFields(fields, requiredFields);
    if (missingFields.length)
      alert(`Missing required fields: ${missingFields.join(", ")}`);
    return missingFields;
  };
  return { checkForRequiredFields, alertMissingFields };
};

export default useRequiredFields;
